import FinanceHubScreenContent from "../../features/financeHub/widgets/FinanceHubScreenContent";

function FinanceHubScreen() {
  return (
    <section className="clients-page" id="Csection" tabIndex="-1">
      <div className="container">
        <FinanceHubScreenContent />
      </div>
    </section>
  );
}

export default FinanceHubScreen;
